import Router from "./components/router/Router";
import DocumentHead from "./components/seo/DocumentHead";
import WhatsAppFloatingButton from "./components/WhatsAppFloatingButton";
import { ToastProvider } from "./providers/ToastProvider";

function App() {
  return (
    <div className="font-sans bg-white text-hColor min-h-screen">
      <DocumentHead />
      <ToastProvider>
        <Router />
        <WhatsAppFloatingButton />
      </ToastProvider>
    </div>
  );
}

export default App;
